"use client";

import { useDisclosure as HeroUseDisclosure } from "@heroui/react";

export const useDisclosure = HeroUseDisclosure;
